import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { breakPoints } from '~/src/constants/breakpoints';

export const LandingWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    margin-bottom: -50px;
    background: ${COLORS.BgLight};
    
    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
    }
`;

export const Container = styled.section`
    max-width: 1362px;
    margin: 0 auto;

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 300px;
    }
`;

export const ContainerFeedbackForm = styled(Container)`
    width: 1362px;
    margin-bottom: 64px;
    box-sizing: content-box;
    padding: 0 90px;

    @media (max-width: ${breakPoints.sDesktop}) {
        padding: 0 34px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        padding: 0 16px;
        max-width: 288px;
    }
`;

export const FeedbackFormWrapper = styled.div`
    position: relative;
    border-radius: 32px;
    background-color: ${COLORS.BgMain};
    justify-content: center;
    padding: 51px 0 33px 0;
    gap: 24px;

    @media (max-width: ${breakPoints.desktop}) {
        gap: 36px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        gap: 26px;
        height: 351px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: 395px;
        padding: 26px 17px 40px 17px;
        border-radius: 16px;
        gap: 0;
    }

    &:after {
        content: '';
        height: 262px;
        width: 150%;
        position: absolute;
        top: 0;
        z-index: -1;
        background-color: ${COLORS.BgMain};

        @media (max-width: ${breakPoints.tablet}) {
            height: 351px;
        }

        @media (max-width: ${breakPoints.mobile}) {
            width: 0;
        }
    }
`;

export const InputWrapper = styled.div`
    flex-direction: row;
    flex-basis: 100%;
    gap: 26px;
    justify-content: center;

    @media (max-width: ${breakPoints.tablet}) {
        gap: 10px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        gap: 0;
    }
`;

export const ButtonWrapper = styled.div`
    flex-direction: column;
    flex-basis: 30%;
    gap: 16px;

    @media (max-width: ${breakPoints.tablet}) {
        flex-basis: 100%;
        align-items: center;
        flex-direction: column-reverse;
        justify-content: end;
        gap: 0;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 254px;
        align-items: flex-start;
    }
`;
